var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcNavCreateOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 6.63758H21.5531C21.4185 6.40937 21.2282 6.21906 21 6.08446L12.75 1.42508C12.5247 1.30032 12.2715 1.23486 12.014 1.23486C11.7566 1.23486 11.5033 1.30032 11.2781 1.42508L3.02809 6.06571C2.79514 6.19731 2.6011 6.38813 2.46559 6.61883C2.46559 6.62006 2.46535 6.62128 2.46488 6.62242C2.46441 6.62356 2.46372 6.62459 2.46285 6.62546C2.46198 6.62633 2.46094 6.62702 2.45981 6.62749C2.45867 6.62796 2.45745 6.62821 2.45622 6.62821V6.64696C2.32496 6.86812 2.25687 7.12104 2.25934 7.37821V16.622C2.25982 16.8892 2.33124 17.1515 2.4663 17.3821C2.60137 17.6127 2.79523 17.8033 3.02809 17.9345L11.2781 22.5751C11.4858 22.6884 11.7167 22.7525 11.9531 22.7626H12.0843C12.3175 22.7511 12.5451 22.687 12.75 22.5751L21 17.9345C21.2304 17.8014 21.4219 17.6101 21.5552 17.3798C21.6884 17.1494 21.7589 16.8881 21.7593 16.622V7.37821C21.7607 7.11822 21.6928 6.86257 21.5625 6.63758ZM12.0093 2.73758L19.4906 6.93758L16.6125 8.56883L9.05622 4.39696L12.0093 2.73758ZM12.0937 11.1376L4.54684 6.93758L7.51872 5.26883L15.0843 9.44071L12.0937 11.1376ZM12.7687 20.8407L12.8437 12.4407L15.8531 10.7251V14.297C15.8531 14.4959 15.9321 14.6866 16.0728 14.8273C16.2134 14.9679 16.4042 15.047 16.6031 15.047C16.802 15.047 16.9928 14.9679 17.1334 14.8273C17.2741 14.6866 17.3531 14.4959 17.3531 14.297V9.87196L20.2593 8.22196V16.622L12.7687 20.8407Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavCreateOrder);
export default __webpack_public_path__ + "static/media/ic_nav_create_order.f403a373146d2ce4582f43b262135c70.svg";
export { ForwardRef as ReactComponent };